if (!customElements.get('snapshot-slider')) {
  customElements.define(
    'snapshot-slider',
    class SnapshotSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.swiper');
        this.itemsDesktop = parseInt(this.dataset.itemsDesktop, 10) || 3;
        this.itemsMobile = parseInt(this.dataset.itemsMobile, 10) || 3;
        this.gap = parseInt(this.dataset.gap, 10) || 20;

        this.initSlider();

        // This carousel normally starts inside a closed <details> accordion
        // panel, so Swiper measures a width of 0 on init and never
        // recalculates on its own - force a re-measure once the panel opens.
        const details = this.closest('details');
        if (details) {
          details.addEventListener('toggle', () => {
            if (details.open) this.sliderInstance?.slider?.update();
          });
        }
      }

      initSlider() {
        const options = {
          slidesPerView: this.itemsMobile,
          spaceBetween: this.gap,
          navigation: false,
          pagination: false,
          watchOverflow: true,
          threshold: 2,
          grabCursor: true,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 0.5,
            thresholdDelta: 30,
            thresholdTime: 500,
          },
          breakpoints: {
            768: {
              slidesPerView: this.itemsDesktop,
            },
          },
        };

        this.sliderInstance = new FoxTheme.Carousel(this.viewport, options);
        this.sliderInstance.init();
      }
    }
  );
}
